import { Box, ColorOptions, IconNew, Image, ModBox, Spacer, Text, useWindowDimensions } from '@jfs/ui-new'
import React, { useState } from 'react'
import { FlatList } from 'react-native'
import { colors } from '../../util/colors'
import useFontSize from '../../util/useFontSize'
import { isMobileWidth } from '../../util/util'
import { LinearGradientContainer } from '../LinearGradient'

interface Props {
  data: any
}
export const BoxLayout = React.memo(({ data }: Props) => {
  const { textSize } = useFontSize()
  const RenderBox = ({ item, isMob }: any) => {
    const [height, setHeight] = useState(0)
    const Component = item.component
    return (
      <>
        <ModBox
          show={height > 0}
          w={isMob ? '92%' : 270}
          h={isMob ? height + 48 : height + 80}
          borderRadius={16}
          borderWidth={1}
          position={'absolute'}
          top={isMob ? 6 : 10}
          left={isMob ? 12 : 10}
          borderColor={'WHITE'}
          zIndex={-100}
        />
        <LinearGradientContainer
          colorArray={item.bg}
          direction="HORIZONTAL"
          useAngle={true}
          angle={135}
          customStyle={{
            borderRadius: 16,
            padding: isMob ? 24 : 40,
            width: isMob ? undefined : 270,
            marginBottom: 40,
            marginRight: isMob ? 8 : 10,
          }}>
          <Box onLayout={(evt: any) => setHeight(evt?.nativeEvent?.layout?.height ?? 0)}>
            {!!Component && <Component height={isMob ? 32 : 40} width={40} />}
            {!!item.imgUrl && <Image source={item.imgUrl} height={isMob ? 32 : 40} width={40} resizeMode="contain" />}
            {!!item.icon && (
              <IconNew size={isMob ? 32 : 40} id={item.icon} color={colors.JIO_PRIMARY_ALPHA as ColorOptions} />
            )}
            <Spacer size={isMob ? 16 : 24} />
            <Text
              title={item.title}
              fontFamily={'jiotype-black'}
              fontSize={textSize}
              color={colors.JIO_PRIMARY_ALPHA as ColorOptions}
              lineHeight={isMob ? 20 : 28}
            />
            <Spacer size={8} />
            <Text
              title={item.subTitle}
              fontFamily={'jiotype-medium'}
              fontSize={isMob ? 12 : 16}
              lineHeight={isMob ? 18 : 24}
              color={colors.JIO_PRIMARY_ALPHA as ColorOptions}
              opacity={0.7}
            />
          </Box>
        </LinearGradientContainer>
      </>
    )
  }

  const viewPortWidth = useWindowDimensions()
  const isMob = isMobileWidth(viewPortWidth)

  return (
    <Box flexDirection={'row'}>
      <Box f={isMob ? 1 : undefined}>
        <FlatList data={data.leftColumn} renderItem={({ item }) => <RenderBox item={item} isMob={isMob} />} />
      </Box>
      <Spacer size={isMob ? 16 : 30} direction={'horizontal'} />
      <Box marginTop={40} f={isMob ? 1 : undefined}>
        <FlatList data={data.rightColumn} renderItem={({ item }) => <RenderBox item={item} isMob={isMob} />} />
      </Box>
    </Box>
  )
})
